import { useQuery } from "@tanstack/react-query";
import { IAssignedModule } from "../../types/generalTypes";
import { qoFetchModuleCompletion } from "../../utils/queryOptions";
import { useAuth } from "../../hooks/useAuth";
import { motion } from "framer-motion";

export default function ModuleTitle({
  cc,
  showCompletion = true,
}: {
  cc: IAssignedModule;
  showCompletion?: boolean;
  showDate?: boolean;
}) {
  const { user } = useAuth();
  const { data: completion } = useQuery(
    qoFetchModuleCompletion({
      module_cohort_id: cc.module_cohort_id,
      user_id: showCompletion ? user?.id : undefined,
    })
  );

  const pct = Math.round(completion?.[0]?.avg_all ?? 0);

  return (
    <div id={`module-${cc.module_id}`} className="py-3 scroll-mt-24">
      <div className="flex items-center gap-2 mb-0.5">
        <span className="shrink-0 text-[11px] font-bold uppercase tracking-wider bg-white/[0.08] text-white/50 px-2 py-0.5 rounded-full">
          Modül {cc.order}
        </span>
      </div>
      <h2 className="text-lg font-semibold truncate">{cc.title}</h2>
      {showCompletion && (
        <div className="mt-2 flex items-center gap-2">
          <div className="flex-1 h-1 bg-white/5 rounded-full overflow-hidden">
            <motion.div
              className="h-full rounded-full bg-gradient-to-r from-myBlue to-myGreen"
              initial={{ width: 0 }}
              animate={{ width: `${pct}%` }}
              transition={{ duration: 0.6, ease: "easeOut" }}
            />
          </div>
          {pct > 0 && (
            <span className="text-[11px] font-semibold text-white/35 shrink-0">%{pct}</span>
          )}
        </div>
      )}
    </div>
  );
}
